import { useState, useEffect } from "react";
import { supabase, isAdminSession } from "./supabase";

const MONTHS_FR = ["Janvier","Février","Mars","Avril","Mai","Juin","Juillet","Août","Septembre","Octobre","Novembre","Décembre"];
const DAYS_FR = ["Dimanche","Lundi","Mardi","Mercredi","Jeudi","Vendredi","Samedi"];
const DAYS_CAL = ["L","M","M","J","V","S","D"];
const SLOTS_ALL = ["09:00","09:45","10:30","11:15","12:00","12:45","13:30","14:15","15:00","15:45","16:30","17:15","18:00"];

function todayISO() {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}

// PostgREST plafonne à 1000 lignes par requête et blocked_slots accumule
// l'historique — sans filtre sur les dates à venir, les blocages récents
// sortent de la fenêtre et deviennent invisibles (tout en s'insérant bien).
function fetchActiveBlocks() {
  return supabase.from("blocked_slots").select("*")
    .or(`date.gte.${todayISO()},date_end.gte.${todayISO()}`);
}

// ✅ LIEN GOOGLE AVIS — remplace par l'URL réelle une fois récupérée
const GOOGLE_REVIEW_URL = "https://search.google.com/local/writereview?placeid=ChIJSVfQkiJjjEcR8JAPeXJgZSw";

const css = `
@import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Lato:wght@300;400;700&display=swap');
*{box-sizing:border-box;margin:0;padding:0;}
:root{--gold:#C8A96E;--dark:#2B2925;--darker:#201E1A;--card:#332F29;--border:rgba(200,169,110,0.2);--muted:#7A7060;}
html,body{background:var(--darker);color:#F0EAE0;font-family:'Lato',sans-serif;}

.login-wrap{min-height:100vh;display:flex;align-items:center;justify-content:center;padding:20px;}
.login-box{background:var(--dark);border:1px solid var(--border);border-radius:8px;padding:36px 28px;width:100%;max-width:360px;}
.login-logo{font-family:'Bebas Neue',sans-serif;font-size:28px;letter-spacing:0.08em;text-align:center;margin-bottom:4px;}
.login-logo span{color:var(--gold);}
.login-sub{font-size:9px;letter-spacing:0.3em;color:var(--muted);text-transform:uppercase;text-align:center;margin-bottom:28px;}
.login-label{font-size:9px;letter-spacing:0.2em;text-transform:uppercase;color:var(--muted);display:block;margin-bottom:7px;}
.login-input{width:100%;background:var(--card);border:1px solid var(--border);border-radius:3px;padding:12px 13px;color:#F0EAE0;font-family:'Lato',sans-serif;font-size:13px;outline:none;transition:border-color .2s;margin-bottom:16px;}
.login-input:focus{border-color:var(--gold);}
.login-btn{width:100%;padding:14px;background:var(--gold);border:none;border-radius:3px;color:var(--darker);font-family:'Bebas Neue',sans-serif;font-size:15px;letter-spacing:0.2em;cursor:pointer;}
.login-btn:disabled{opacity:0.4;cursor:not-allowed;}
.login-error{font-size:11px;color:#e07070;text-align:center;margin-top:10px;}

.admin{min-height:100vh;background:var(--darker);}
.admin-hdr{background:var(--dark);border-bottom:1px solid var(--border);padding:14px 16px;display:flex;align-items:center;justify-content:space-between;}
.admin-title{font-family:'Bebas Neue',sans-serif;font-size:20px;letter-spacing:0.08em;}
.admin-title span{color:var(--gold);}
.admin-email{font-size:9px;color:var(--muted);letter-spacing:0.1em;margin-top:2px;}
.logout-btn{background:none;border:1px solid var(--border);border-radius:3px;color:var(--muted);font-family:'Lato',sans-serif;font-size:10px;letter-spacing:0.1em;padding:6px 12px;cursor:pointer;}

.stats{display:grid;grid-template-columns:repeat(3,1fr);gap:8px;padding:12px 16px;}
.stat{background:var(--dark);border:1px solid var(--border);border-radius:3px;padding:12px;text-align:center;}
.stat-num{font-family:'Bebas Neue',sans-serif;font-size:26px;color:var(--gold);line-height:1;}
.stat-label{font-size:8px;letter-spacing:0.15em;color:var(--muted);text-transform:uppercase;margin-top:2px;}

.tabs{display:flex;background:var(--dark);border-bottom:1px solid var(--border);overflow-x:auto;}
.tab{flex-shrink:0;padding:10px 8px;background:none;border:none;color:var(--muted);font-family:'Lato',sans-serif;font-size:8.5px;letter-spacing:0.12em;text-transform:uppercase;cursor:pointer;position:relative;transition:color .2s;white-space:nowrap;}
.tab.on{color:var(--gold);}
.tab.on::after{content:'';position:absolute;bottom:0;left:0;right:0;height:1.5px;background:var(--gold);}

.pg{padding:14px 16px;}

.planning-grid{display:grid;grid-template-columns:1fr 1fr;gap:10px;}
.planning-col{background:var(--dark);border:1px solid var(--border);border-radius:3px;overflow:hidden;}
.planning-col-hdr{padding:10px 12px;border-bottom:1px solid var(--border);background:rgba(200,169,110,.06);}
.planning-col-day{font-family:'Bebas Neue',sans-serif;font-size:15px;letter-spacing:0.06em;}
.planning-col-day.today{color:var(--gold);}
.planning-col-date{font-size:9px;color:var(--muted);letter-spacing:0.1em;margin-top:1px;}
.planning-col-body{padding:8px;}
.planning-slot{border-left:2px solid var(--gold);background:rgba(200,169,110,.08);border-radius:0 3px 3px 0;padding:8px 10px;margin-bottom:6px;}
.planning-slot-time{font-size:10px;color:var(--gold);letter-spacing:0.1em;margin-bottom:2px;}
.planning-slot-name{font-family:'Bebas Neue',sans-serif;font-size:15px;letter-spacing:0.04em;}
.planning-slot-svc{font-size:9px;color:var(--muted);margin-top:1px;}
.planning-slot-tel{font-size:9px;color:var(--muted);margin-top:2px;}
.planning-slot-cancelled{border-left:2px solid #d08080;background:rgba(200,80,80,0.07);border-radius:0 3px 3px 0;padding:8px 10px;margin-bottom:6px;opacity:0.8;}
.planning-slot-cancelled .planning-slot-time{color:#d08080;}
.planning-slot-cancelled .planning-slot-name{text-decoration:line-through;color:var(--muted);}
.cancelled-divider{font-size:8px;letter-spacing:0.2em;color:#d08080;text-transform:uppercase;padding:6px 0 4px;border-top:1px solid rgba(200,80,80,0.15);margin-top:6px;}

.cal-nav{display:flex;align-items:center;justify-content:space-between;margin-bottom:12px;}
.cal-nav-btn{background:none;border:1px solid var(--border);border-radius:3px;color:var(--muted);width:32px;height:32px;cursor:pointer;font-size:16px;display:flex;align-items:center;justify-content:center;}
.cal-month{font-family:'Bebas Neue',sans-serif;font-size:18px;letter-spacing:0.08em;}
.cal-month span{color:var(--gold);}
.cal-labels{display:grid;grid-template-columns:repeat(7,1fr);gap:2px;margin-bottom:4px;}
.cal-label{text-align:center;font-size:8px;color:var(--muted);padding-bottom:4px;}
.cal-grid{display:grid;grid-template-columns:repeat(7,1fr);gap:2px;margin-bottom:14px;}
.cal-day{background:var(--dark);border:1px solid var(--border);border-radius:2px;padding:5px 3px;cursor:pointer;text-align:center;min-height:40px;transition:all .15s;}
.cal-day.today{border-color:rgba(200,169,110,.5);background:rgba(200,169,110,.06);}
.cal-day.sel{border-color:var(--gold);background:rgba(200,169,110,.15);}
.cal-day-num{font-size:11px;color:#F0EAE0;}
.cal-day.today .cal-day-num{color:var(--gold);font-weight:700;}
.cal-dot{width:5px;height:5px;background:var(--gold);border-radius:50%;margin:2px auto 0;}
.cal-count{font-size:7px;color:var(--gold);margin-top:1px;}
.cal-detail-title{font-family:'Bebas Neue',sans-serif;font-size:15px;letter-spacing:0.06em;color:var(--gold);margin-bottom:10px;}

.rdv-card{background:var(--dark);border:1px solid var(--border);border-radius:3px;padding:12px;margin-bottom:8px;}
.rdv-top{display:flex;justify-content:space-between;align-items:flex-start;margin-bottom:8px;}
.rdv-name{font-family:'Bebas Neue',sans-serif;font-size:17px;letter-spacing:0.04em;}
.rdv-badge{font-size:8px;letter-spacing:0.15em;text-transform:uppercase;padding:3px 7px;border-radius:2px;background:rgba(50,180,100,0.12);border:1px solid rgba(50,180,100,0.3);color:#7dca9a;}
.rdv-info{display:grid;grid-template-columns:1fr 1fr;gap:5px;margin-bottom:8px;}
.rdv-info-label{font-size:8px;letter-spacing:0.15em;color:var(--muted);text-transform:uppercase;margin-bottom:1px;}
.rdv-info-val{font-size:11px;color:#D0CAC0;}
.rdv-info-val.gold{color:var(--gold);}
.rdv-actions{display:flex;gap:6px;flex-wrap:wrap;}
.rdv-btn{flex:1;min-width:60px;padding:7px;border-radius:2px;font-family:'Lato',sans-serif;font-size:9px;letter-spacing:0.08em;cursor:pointer;transition:all .2s;text-transform:uppercase;text-align:center;}
.rdv-btn-call{background:rgba(50,180,100,0.1);border:1px solid rgba(50,180,100,0.3);color:#7dca9a;}
.rdv-btn-cancel{background:rgba(200,80,80,0.08);border:1px solid rgba(200,80,80,0.2);color:#d08080;}
/* ✅ Bouton Terminer */
.rdv-btn-done{background:rgba(200,169,110,0.12);border:1px solid rgba(200,169,110,0.4);color:var(--gold);}
.rdv-btn-done:hover{background:rgba(200,169,110,0.22);}
.rdv-btn-done:disabled{opacity:0.4;cursor:not-allowed;}

.empty{text-align:center;padding:30px 20px;color:var(--muted);font-size:12px;}
.refresh-btn{background:none;border:1px solid var(--border);border-radius:3px;color:var(--muted);font-family:'Lato',sans-serif;font-size:10px;letter-spacing:0.1em;padding:6px 12px;cursor:pointer;margin-bottom:12px;}
.loading{text-align:center;padding:30px;color:var(--muted);font-size:11px;letter-spacing:0.15em;}

/* BLOCAGE */
.block-section{margin-bottom:20px;}
.block-section-title{font-family:'Bebas Neue',sans-serif;font-size:14px;letter-spacing:0.12em;color:var(--muted);text-transform:uppercase;border-bottom:1px solid var(--border);padding-bottom:6px;margin-bottom:12px;}
.block-type-row{display:flex;gap:6px;margin-bottom:14px;}
.block-type-btn{flex:1;padding:8px 4px;background:var(--dark);border:1px solid var(--border);border-radius:3px;color:var(--muted);font-family:'Lato',sans-serif;font-size:9px;letter-spacing:0.1em;text-transform:uppercase;cursor:pointer;text-align:center;transition:all .2s;}
.block-type-btn.on{border-color:var(--gold);color:var(--gold);background:rgba(200,169,110,.08);}
.block-field{margin-bottom:12px;}
.block-label{display:block;font-size:9px;letter-spacing:0.2em;text-transform:uppercase;color:var(--muted);margin-bottom:6px;}
.block-input{width:100%;background:var(--card);border:1px solid var(--border);border-radius:3px;padding:10px 12px;color:#F0EAE0;font-family:'Lato',sans-serif;font-size:13px;outline:none;transition:border-color .2s;}
.block-input:focus{border-color:var(--gold);}
.block-select{width:100%;background:var(--card);border:1px solid var(--border);border-radius:3px;padding:10px 12px;color:#F0EAE0;font-family:'Lato',sans-serif;font-size:13px;outline:none;cursor:pointer;}
.block-btn{width:100%;padding:12px;background:rgba(200,80,80,0.15);border:1px solid rgba(200,80,80,0.35);border-radius:3px;color:#d08080;font-family:'Bebas Neue',sans-serif;font-size:14px;letter-spacing:0.2em;cursor:pointer;transition:all .2s;margin-top:4px;}
.block-btn:disabled{opacity:0.4;cursor:not-allowed;}
.block-list{display:flex;flex-direction:column;gap:7px;}
.block-item{background:var(--dark);border:1px solid rgba(200,80,80,0.2);border-radius:3px;padding:10px 12px;display:flex;align-items:center;justify-content:space-between;gap:10px;}
.block-item-info{flex:1;}
.block-item-type{font-size:8px;letter-spacing:0.15em;text-transform:uppercase;color:#d08080;margin-bottom:3px;}
.block-item-date{font-family:'Bebas Neue',sans-serif;font-size:15px;color:#F0EAE0;}
.block-item-label{font-size:10px;color:var(--muted);margin-top:2px;}
.block-del{background:none;border:1px solid rgba(200,80,80,0.3);border-radius:2px;color:#d08080;font-size:11px;padding:5px 10px;cursor:pointer;}
.block-success{font-size:11px;color:#7dca9a;text-align:center;margin-top:8px;}
.block-error{font-size:11px;color:#e07070;text-align:center;margin-top:8px;}
`;

function formatDate(d) {
  return `${d.getDate()}.${String(d.getMonth()+1).padStart(2,'0')}.${d.getFullYear()}`;
}

function getRdvsForDate(reservations, dateStr) {
  return reservations
    .filter(r => r.statut === "confirmé" && r.date && r.date.includes(dateStr))
    .sort((a, b) => a.heure?.localeCompare(b.heure));
}

export default function AdminPanel() {
  const [session, setSession] = useState(null);
  const [checking, setChecking] = useState(true);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loginError, setLoginError] = useState("");
  const [loginLoading, setLoginLoading] = useState(false);
  const [tab, setTab] = useState("planning");
  const [reservations, setReservations] = useState([]);
  const [loading, setLoading] = useState(false);
  const [sendingReview, setSendingReview] = useState(null);

  useEffect(() => {
    // Un compte client (Google ou email role "client") n'est JAMAIS traité comme admin
    supabase.auth.getSession().then(({ data: { session } }) => {
      const s = isAdminSession(session) ? session : null;
      setSession(s); setChecking(false);
      if (s) loadReservations();
    });
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_e, session) => {
      const s = isAdminSession(session) ? session : null;
      setSession(s);
      if (s) loadReservations();
    });
    return () => subscription.unsubscribe();
  }, []);

  async function login() {
    setLoginLoading(true); setLoginError("");
    const { data, error } = await supabase.auth.signInWithPassword({ email, password });
    if (error) { setLoginError("Email ou mot de passe incorrect"); setLoginLoading(false); return; }
    if (!isAdminSession(data?.session)) setLoginError("Accès réservé au salon");
    setLoginLoading(false);
  }

  async function logout() { await supabase.auth.signOut(); setSession(null); setReservations([]); }

  async function loadReservations() {
    setLoading(true);
    const { data } = await supabase.from("reservations").select("*").order("created_at", { ascending: false });
    setReservations(data || []);
    setLoading(false);
  }

  async function cancelRdv(id) {
    await supabase.from("reservations").update({ statut: "annulé" }).eq("id", id);
    loadReservations();
  }

  // ✅ Terminer la prestation → SMS Google Avis
  async function terminerRdv(rdv) {
    setSendingReview(rdv.id);
    const message = `Merci ${rdv.nom.split(" ")[0]} pour votre visite chez Mendes Cut ! 🙏✂️
Votre avis nous aide beaucoup. Laissez-nous 30 secondes sur Google :
${GOOGLE_REVIEW_URL}`;
    try {
      await fetch("https://mendescut-barbershop.com/api/send-sms", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          to: rdv.telephone,
          clientName: rdv.nom,
          service: rdv.service,
          date: rdv.date,
          heure: rdv.heure,
          total: rdv.total,
          reviewMessage: message,
        }),
      });
      await supabase.from("reservations").update({ statut: "terminé" }).eq("id", rdv.id);
      loadReservations();
    } catch (e) {
      console.error("Erreur envoi avis:", e);
    }
    setSendingReview(null);
  }

  const today = new Date();
  const tomorrow = new Date(today);
  tomorrow.setDate(today.getDate() + 1);
  const todayStr = formatDate(today);
  const tomorrowStr = formatDate(tomorrow);
  const todayRdvs = getRdvsForDate(reservations, todayStr);
  const tomorrowRdvs = getRdvsForDate(reservations, tomorrowStr);
  const confirmedRdvs = reservations.filter(r => r.statut === "confirmé");
  const todayCancelled = reservations.filter(r => r.statut === "annulé" && r.date && r.date.includes(todayStr)).sort((a,b) => a.heure?.localeCompare(b.heure));
  const tomorrowCancelled = reservations.filter(r => r.statut === "annulé" && r.date && r.date.includes(tomorrowStr)).sort((a,b) => a.heure?.localeCompare(b.heure));

  if (checking) return (<><style>{css}</style><div className="login-wrap"><div className="loading">Vérification...</div></div></>);

  if (!session) return (
    <>
      <style>{css}</style>
      <div className="login-wrap">
        <div className="login-box">
          <div className="login-logo">MENDES <span>✂</span> CUT</div>
          <div className="login-sub">Espace administrateur</div>
          <label className="login-label">Email</label>
          <input className="login-input" type="email" placeholder="admin@mendescut.com" value={email} onChange={e => setEmail(e.target.value)} onKeyDown={e => e.key === "Enter" && login()} />
          <label className="login-label">Mot de passe</label>
          <input className="login-input" type="password" placeholder="••••••••••" value={password} onChange={e => setPassword(e.target.value)} onKeyDown={e => e.key === "Enter" && login()} />
          <button className="login-btn" onClick={login} disabled={loginLoading}>{loginLoading ? "Connexion..." : "Accéder au panel →"}</button>
          {loginError && <div className="login-error">{loginError}</div>}
        </div>
      </div>
    </>
  );

  const RdvCard = ({ r, showTerminer = true }) => (
    <div className="rdv-card">
      <div className="rdv-top">
        <div className="rdv-name">{r.nom}</div>
        <span className="rdv-badge">Confirmé</span>
      </div>
      <div className="rdv-info">
        <div><div className="rdv-info-label">Service</div><div className="rdv-info-val gold">{r.service}</div></div>
        <div><div className="rdv-info-label">Total</div><div className="rdv-info-val gold">{r.total} CHF</div></div>
        <div><div className="rdv-info-label">Date</div><div className="rdv-info-val">{r.date}</div></div>
        <div><div className="rdv-info-label">Heure</div><div className="rdv-info-val">{r.heure}</div></div>
        <div><div className="rdv-info-label">Téléphone</div><div className="rdv-info-val">{r.telephone}</div></div>
        {r.supplements && <div><div className="rdv-info-label">Suppléments</div><div className="rdv-info-val" style={{fontSize:9}}>{r.supplements}</div></div>}
      </div>
      <div className="rdv-actions">
        <button className="rdv-btn rdv-btn-call" onClick={() => window.open(`tel:${r.telephone}`)}>📞 Appeler</button>
        {showTerminer && (
          <button className="rdv-btn rdv-btn-done" onClick={() => terminerRdv(r)} disabled={sendingReview === r.id}>
            {sendingReview === r.id ? "Envoi..." : "⭐ Terminer"}
          </button>
        )}
        <button className="rdv-btn rdv-btn-cancel" onClick={() => cancelRdv(r.id)}>✕ Annuler</button>
      </div>
    </div>
  );

  return (
    <>
      <style>{css}</style>
      <div className="admin">
        <div className="admin-hdr">
          <div>
            <div className="admin-title">MENDES <span>✂</span> CUT</div>
            <div className="admin-email">{session.user.email}</div>
          </div>
          <button className="logout-btn" onClick={logout}>Déconnexion</button>
        </div>

        <div className="stats">
          <div className="stat"><div className="stat-num">{todayRdvs.length}</div><div className="stat-label">Aujourd'hui</div></div>
          <div className="stat"><div className="stat-num">{tomorrowRdvs.length}</div><div className="stat-label">Demain</div></div>
          <div className="stat"><div className="stat-num">{confirmedRdvs.length}</div><div className="stat-label">Total RDV</div></div>
        </div>

        <div className="tabs">
          <button className={`tab ${tab === "planning" ? "on" : ""}`} onClick={() => setTab("planning")}>📅 Planning</button>
          <button className={`tab ${tab === "cal" ? "on" : ""}`} onClick={() => setTab("cal")}>🗓 Calendrier</button>
          <button className={`tab ${tab === "all" ? "on" : ""}`} onClick={() => setTab("all")}>📋 Tous</button>
          <button className={`tab ${tab === "stats" ? "on" : ""}`} onClick={() => setTab("stats")}>📊 Stats</button>
          <button className={`tab ${tab === "blocage" ? "on" : ""}`} onClick={() => setTab("blocage")}>🔒 Blocage</button>
          <button className={`tab ${tab === "weekly" ? "on" : ""}`} onClick={() => setTab("weekly")}>📆 Semainier</button>
        </div>

        <div className="pg">
          {tab !== "blocage" && tab !== "weekly" && <button className="refresh-btn" onClick={loadReservations}>↻ Actualiser</button>}
          {loading && <div className="loading">Chargement...</div>}

          {/* PLANNING */}
          {!loading && tab === "planning" && (
            <div className="planning-grid">
              <div className="planning-col">
                <div className="planning-col-hdr">
                  <div className="planning-col-day today">Aujourd'hui</div>
                  <div className="planning-col-date">{DAYS_FR[today.getDay()]} {today.getDate()} {MONTHS_FR[today.getMonth()]}</div>
                </div>
                <div className="planning-col-body">
                  {todayRdvs.length === 0 && todayCancelled.length === 0 ? <div className="planning-empty">Aucun RDV</div> : <>
                    {todayRdvs.map(r => (
                      <div key={r.id} className="planning-slot">
                        <div className="planning-slot-time">{r.heure}</div>
                        <div className="planning-slot-name">{r.nom}</div>
                        <div className="planning-slot-svc">{r.service}</div>
                        <div className="planning-slot-tel">{r.telephone}</div>
                        <button
                          onClick={() => terminerRdv(r)}
                          disabled={sendingReview === r.id}
                          style={{ marginTop: 6, width: "100%", padding: "5px", background: "rgba(200,169,110,0.12)", border: "1px solid rgba(200,169,110,0.4)", borderRadius: 2, color: "#C8A96E", fontSize: 9, letterSpacing: "0.1em", cursor: "pointer", textTransform: "uppercase" }}
                        >
                          {sendingReview === r.id ? "Envoi..." : "⭐ Terminer & Avis"}
                        </button>
                      </div>
                    ))}
                    {todayCancelled.length > 0 && (
                      <>
                        <div className="cancelled-divider">❌ Annulés ({todayCancelled.length})</div>
                        {todayCancelled.map(r => (
                          <div key={r.id} className="planning-slot-cancelled">
                            <div className="planning-slot-time">{r.heure}</div>
                            <div className="planning-slot-name">{r.nom}</div>
                            <div className="planning-slot-svc">{r.service}</div>
                            <div className="planning-slot-tel">{r.telephone}</div>
                          </div>
                        ))}
                      </>
                    )}
                  </>}
                </div>
              </div>
              <div className="planning-col">
                <div className="planning-col-hdr">
                  <div className="planning-col-day">Demain</div>
                  <div className="planning-col-date">{DAYS_FR[tomorrow.getDay()]} {tomorrow.getDate()} {MONTHS_FR[tomorrow.getMonth()]}</div>
                </div>
                <div className="planning-col-body">
                  {tomorrowRdvs.length === 0 && tomorrowCancelled.length === 0 ? <div className="planning-empty">Aucun RDV</div> : <>
                    {tomorrowRdvs.map(r => (
                      <div key={r.id} className="planning-slot">
                        <div className="planning-slot-time">{r.heure}</div>
                        <div className="planning-slot-name">{r.nom}</div>
                        <div className="planning-slot-svc">{r.service}</div>
                        <div className="planning-slot-tel">{r.telephone}</div>
                      </div>
                    ))}
                    {tomorrowCancelled.length > 0 && (
                      <>
                        <div className="cancelled-divider">❌ Annulés ({tomorrowCancelled.length})</div>
                        {tomorrowCancelled.map(r => (
                          <div key={r.id} className="planning-slot-cancelled">
                            <div className="planning-slot-time">{r.heure}</div>
                            <div className="planning-slot-name">{r.nom}</div>
                            <div className="planning-slot-svc">{r.service}</div>
                            <div className="planning-slot-tel">{r.telephone}</div>
                          </div>
                        ))}
                      </>
                    )}
                  </>}
                </div>
              </div>
            </div>
          )}

          {/* CALENDRIER */}
          {!loading && tab === "cal" && <CalendarView reservations={reservations} onCancel={cancelRdv} onTerminer={terminerRdv} sendingReview={sendingReview} />}

          {/* TOUS */}
          {!loading && tab === "all" && (
            <>
              {confirmedRdvs.length === 0 ? <div className="empty">Aucun rendez-vous confirmé</div>
                : confirmedRdvs.map(r => <RdvCard key={r.id} r={r} />)}
            </>
          )}

          {/* STATS */}
          {!loading && tab === "stats" && <StatsView reservations={reservations} />}

          {/* BLOCAGE */}
          {tab === "blocage" && <BlockageView />}

          {/* SEMAINIER */}
          {tab === "weekly" && <WeeklyView reservations={reservations} />}
        </div>
      </div>
    </>
  );
}

// ══════════════════════════════════════════
// WEEKLY VIEW
// ══════════════════════════════════════════
function WeeklyView({ reservations }) {
  const [weekOffset, setWeekOffset] = useState(0);
  const [blockedSlots, setBlockedSlots] = useState([]);
  const [saving, setSaving] = useState(false);
  const [slotMsg, setSlotMsg] = useState(null);
  const [rangeStart, setRangeStart] = useState("");
  const [rangeEnd, setRangeEnd] = useState("");
  const [rangeLabel, setRangeLabel] = useState("");
  const [savingRange, setSavingRange] = useState(false);
  const [rangeMsg, setRangeMsg] = useState(null);

  useEffect(() => { fetchBlocked(); }, []);

  async function fetchBlocked() {
    const { data, error } = await fetchActiveBlocks();
    if (error) console.error("Chargement blocked_slots échoué:", error);
    setBlockedSlots(data || []);
  }

  // Calcule le lundi de la semaine courante + offset
  function getWeekDays() {
    const now = new Date();
    const day = now.getDay();
    const monday = new Date(now);
    monday.setDate(now.getDate() - (day === 0 ? 6 : day - 1) + weekOffset * 7);
    monday.setHours(0, 0, 0, 0);
    const days = [];
    for (let i = 0; i < 6; i++) {
      const d = new Date(monday);
      d.setDate(monday.getDate() + i);
      days.push(d);
    }
    return days;
  }

  function toISO(date) {
    return `${date.getFullYear()}-${String(date.getMonth()+1).padStart(2,'0')}-${String(date.getDate()).padStart(2,'0')}`;
  }

  function isSlotBlocked(dateISO, heure) {
    return blockedSlots.some(b => {
      if (b.type === "slot") return b.date === dateISO && b.heure === heure;
      if (b.type === "day") return b.date === dateISO;
      if (b.type === "range") return dateISO >= b.date && dateISO <= b.date_end;
      return false;
    });
  }

  function isSlotReserved(dateISO, heure) {
    return reservations.some(r => {
      if (r.statut !== "confirmé" || !r.date || !r.heure) return false;
      const parts = r.date.match(/(\d{1,2})\.(\d{2})\.(\d{4})/);
      if (!parts) return false;
      const rISO = `${parts[3]}-${parts[2]}-${String(parts[1]).padStart(2,"0")}`;
      return rISO === dateISO && r.heure === heure;
    });
  }

  function getReservation(dateISO, heure) {
    return reservations.find(r => {
      if (r.statut !== "confirmé" || !r.date || !r.heure) return false;
      const parts = r.date.match(/(\d{1,2})\.(\d{2})\.(\d{4})/);
      if (!parts) return false;
      const rISO = `${parts[3]}-${parts[2]}-${String(parts[1]).padStart(2,"0")}`;
      return rISO === dateISO && r.heure === heure;
    });
  }

  async function toggleSlot(dateISO, heure) {
    if (saving) return;
    const blocked = isSlotBlocked(dateISO, heure);
    const reserved = isSlotReserved(dateISO, heure);
    if (reserved) return; // Ne pas modifier les RDV clients

    setSaving(true);
    setSlotMsg(null);
    let error = null;
    if (blocked) {
      // Trouver le blocage correspondant et le supprimer
      const block = blockedSlots.find(b => b.type === "slot" && b.date === dateISO && b.heure === heure);
      if (block) {
        ({ error } = await supabase.from("blocked_slots").delete().eq("id", block.id));
      }
    } else {
      // Créer un blocage
      ({ error } = await supabase.from("blocked_slots").insert([{ type: "slot", date: dateISO, heure, label: null }]));
    }
    if (error) {
      console.error("Blocage créneau échoué:", error);
      setSlotMsg(`Erreur : ${error.message}${error.code ? ` [${error.code}]` : ""}`);
    }
    await fetchBlocked();
    setSaving(false);
  }

  async function blockRange() {
    if (!rangeStart || !rangeEnd) return;
    setSavingRange(true);
    setRangeMsg(null);
    const { error } = await supabase.from("blocked_slots").insert([{
      type: "range", date: rangeStart, date_end: rangeEnd,
      label: rangeLabel || "Vacances",
    }]);
    if (error) setRangeMsg({ type: "err", text: "Erreur" });
    else {
      setRangeMsg({ type: "ok", text: "Période bloquée ✓" });
      setRangeStart(""); setRangeEnd(""); setRangeLabel("");
      fetchBlocked();
    }
    setSavingRange(false);
  }

  async function deleteBlock(id) {
    await supabase.from("blocked_slots").delete().eq("id", id);
    fetchBlocked();
  }

  const days = getWeekDays();
  const today = new Date(); today.setHours(0,0,0,0);
  const DAY_NAMES = ["Lun", "Mar", "Mer", "Jeu", "Ven", "Sam"];
  const MONTHS_SHORT = ["Jan","Fév","Mar","Avr","Mai","Juin","Juil","Août","Sep","Oct","Nov","Déc"];

  // Calcul de la semaine affichée
  const weekLabel = `${days[0].getDate()} ${MONTHS_SHORT[days[0].getMonth()]} — ${days[5].getDate()} ${MONTHS_SHORT[days[5].getMonth()]} ${days[5].getFullYear()}`;

  // Blocages actifs de type range/day
  const activeBlocks = blockedSlots.filter(b => b.type === "range" || b.type === "day");

  return (
    <div style={{ paddingBottom: 40 }}>
      {/* Navigation semaine */}
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 14 }}>
        <button onClick={() => setWeekOffset(w => w - 1)} style={{ background: "none", border: "1px solid var(--border)", borderRadius: 3, color: "var(--muted)", width: 34, height: 34, cursor: "pointer", fontSize: 18 }}>‹</button>
        <div style={{ textAlign: "center" }}>
          <div style={{ fontFamily: "'Bebas Neue',sans-serif", fontSize: 16, letterSpacing: "0.06em" }}>{weekLabel}</div>
          {weekOffset !== 0 && (
            <button onClick={() => setWeekOffset(0)} style={{ background: "none", border: "none", color: "var(--gold)", fontSize: 10, letterSpacing: "0.1em", cursor: "pointer", textDecoration: "underline" }}>
              Cette semaine
            </button>
          )}
        </div>
        <button onClick={() => setWeekOffset(w => w + 1)} style={{ background: "none", border: "1px solid var(--border)", borderRadius: 3, color: "var(--muted)", width: 34, height: 34, cursor: "pointer", fontSize: 18 }}>›</button>
      </div>

      {/* Légende */}
      <div style={{ display: "flex", gap: 10, marginBottom: 12, flexWrap: "wrap" }}>
        {[
          { color: "var(--card)", border: "var(--border)", label: "Libre" },
          { color: "rgba(200,80,80,0.15)", border: "rgba(200,80,80,0.4)", label: "Bloqué" },
          { color: "rgba(200,169,110,0.15)", border: "var(--gold)", label: "Réservé" },
        ].map(l => (
          <div key={l.label} style={{ display: "flex", alignItems: "center", gap: 5, fontSize: 10, color: "var(--muted)" }}>
            <div style={{ width: 12, height: 12, borderRadius: 2, background: l.color, border: `1px solid ${l.border}` }} />
            {l.label}
          </div>
        ))}
      </div>

      {/* Grille semaine */}
      <div style={{ overflowX: "auto" }}>
        <div style={{ display: "grid", gridTemplateColumns: `60px repeat(6, 1fr)`, gap: 2, minWidth: 420 }}>
          {/* Header jours */}
          <div />
          {days.map((d, i) => {
            const isToday = d.getTime() === today.getTime();
            return (
              <div key={i} style={{
                textAlign: "center", padding: "6px 2px",
                background: isToday ? "rgba(200,169,110,0.12)" : "var(--dark)",
                borderRadius: 3, border: isToday ? "1px solid var(--gold)" : "1px solid var(--border)"
              }}>
                <div style={{ fontSize: 9, color: isToday ? "var(--gold)" : "var(--muted)", letterSpacing: "0.1em" }}>{DAY_NAMES[i]}</div>
                <div style={{ fontFamily: "'Bebas Neue',sans-serif", fontSize: 16, color: isToday ? "var(--gold)" : "#F0EAE0" }}>{d.getDate()}</div>
              </div>
            );
          })}

          {/* Créneaux */}
          {SLOTS_ALL.map(slot => (
            <>
              {/* Label heure */}
              <div key={`label-${slot}`} style={{ display: "flex", alignItems: "center", justifyContent: "flex-end", paddingRight: 6, fontSize: 9, color: "var(--muted)", letterSpacing: "0.08em" }}>
                {slot}
              </div>
              {days.map((d, di) => {
                const dateISO = toISO(d);
                const blocked = isSlotBlocked(dateISO, slot);
                const reserved = isSlotReserved(dateISO, slot);
                const rdv = reserved ? getReservation(dateISO, slot) : null;
                const isPast = d < today;

                let bg = "var(--card)";
                let border = "rgba(200,169,110,0.08)";
                let cursor = "pointer";
                let title = "Cliquer pour bloquer";

                if (isPast) { bg = "rgba(0,0,0,0.2)"; cursor = "default"; border = "transparent"; title = ""; }
                else if (reserved) { bg = "rgba(200,169,110,0.15)"; border = "var(--gold)"; cursor = "default"; title = rdv ? `${rdv.nom} — ${rdv.service}` : "Réservé"; }
                else if (blocked) { bg = "rgba(200,80,80,0.15)"; border = "rgba(200,80,80,0.4)"; title = "Cliquer pour débloquer"; }

                return (
                  <div key={`${di}-${slot}`}
                    title={title}
                    onClick={() => !isPast && !reserved && toggleSlot(dateISO, slot)}
                    style={{
                      height: 28, borderRadius: 2,
                      background: bg, border: `1px solid ${border}`,
                      cursor, transition: "all 0.15s",
                      display: "flex", alignItems: "center", justifyContent: "center",
                      overflow: "hidden",
                    }}
                  >
                    {reserved && rdv && (
                      <div style={{ fontSize: 7, color: "var(--gold)", letterSpacing: "0.05em", textAlign: "center", padding: "0 2px", overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis", maxWidth: "100%" }}>
                        {rdv.nom?.split(" ")[0]}
                      </div>
                    )}
                    {blocked && !reserved && (
                      <div style={{ fontSize: 8, color: "#d08080" }}>✕</div>
                    )}
                  </div>
                );
              })}
            </>
          ))}
        </div>
      </div>

      {slotMsg && (
        <div style={{ marginTop: 8, fontSize: 11, color: "#e07070", textAlign: "center" }}>{slotMsg}</div>
      )}

      {/* Blocage par plage */}
      <div style={{ marginTop: 24, background: "var(--dark)", border: "1px solid var(--border)", borderRadius: 6, padding: 14 }}>
        <div style={{ fontFamily: "'Bebas Neue',sans-serif", fontSize: 14, letterSpacing: "0.1em", color: "var(--gold)", marginBottom: 12 }}>
          📆 Bloquer une période (vacances, fermeture...)
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8, marginBottom: 8 }}>
          <div>
            <div style={{ fontSize: 9, letterSpacing: "0.15em", color: "var(--muted)", textTransform: "uppercase", marginBottom: 5 }}>Du</div>
            <input type="date" value={rangeStart} onChange={e => setRangeStart(e.target.value)}
              style={{ width: "100%", background: "var(--card)", border: "1px solid var(--border)", borderRadius: 3, padding: "8px 10px", color: "#F0EAE0", fontFamily: "'Lato',sans-serif", fontSize: 12, outline: "none" }} />
          </div>
          <div>
            <div style={{ fontSize: 9, letterSpacing: "0.15em", color: "var(--muted)", textTransform: "uppercase", marginBottom: 5 }}>Au</div>
            <input type="date" value={rangeEnd} min={rangeStart} onChange={e => setRangeEnd(e.target.value)}
              style={{ width: "100%", background: "var(--card)", border: "1px solid var(--border)", borderRadius: 3, padding: "8px 10px", color: "#F0EAE0", fontFamily: "'Lato',sans-serif", fontSize: 12, outline: "none" }} />
          </div>
        </div>
        <input type="text" placeholder="Motif (ex: Vacances d'été)" value={rangeLabel} onChange={e => setRangeLabel(e.target.value)}
          style={{ width: "100%", background: "var(--card)", border: "1px solid var(--border)", borderRadius: 3, padding: "8px 10px", color: "#F0EAE0", fontFamily: "'Lato',sans-serif", fontSize: 12, outline: "none", marginBottom: 8 }} />
        <button onClick={blockRange} disabled={!rangeStart || !rangeEnd || savingRange}
          style={{ width: "100%", padding: 10, background: "rgba(200,80,80,0.15)", border: "1px solid rgba(200,80,80,0.35)", borderRadius: 3, color: "#d08080", fontFamily: "'Bebas Neue',sans-serif", fontSize: 13, letterSpacing: "0.15em", cursor: "pointer" }}>
          {savingRange ? "Enregistrement..." : "🔒 Bloquer toute la période"}
        </button>
        {rangeMsg && <div style={{ fontSize: 11, color: rangeMsg.type === "ok" ? "#7dca9a" : "#e07070", textAlign: "center", marginTop: 8 }}>{rangeMsg.text}</div>}
      </div>

      {/* Liste des blocages actifs */}
      {activeBlocks.length > 0 && (
        <div style={{ marginTop: 16 }}>
          <div style={{ fontFamily: "'Bebas Neue',sans-serif", fontSize: 13, letterSpacing: "0.1em", color: "var(--muted)", marginBottom: 8, borderBottom: "1px solid var(--border)", paddingBottom: 6 }}>
            Périodes bloquées ({activeBlocks.length})
          </div>
          {activeBlocks.map(b => (
            <div key={b.id} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", background: "var(--dark)", border: "1px solid rgba(200,80,80,0.2)", borderRadius: 3, padding: "8px 12px", marginBottom: 6 }}>
              <div>
                <div style={{ fontSize: 8, letterSpacing: "0.15em", color: "#d08080", textTransform: "uppercase", marginBottom: 2 }}>
                  {b.type === "range" ? `Du ${b.date} au ${b.date_end}` : b.date}
                </div>
                {b.label && <div style={{ fontSize: 11, color: "var(--muted)" }}>📌 {b.label}</div>}
              </div>
              <button onClick={() => deleteBlock(b.id)} style={{ background: "none", border: "1px solid rgba(200,80,80,0.3)", borderRadius: 2, color: "#d08080", fontSize: 11, padding: "4px 9px", cursor: "pointer" }}>✕</button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

// ══════════════════════════════════════════
// BLOCAGE VIEW
// ══════════════════════════════════════════
function BlockageView() {
  const [blockType, setBlockType] = useState("day");
  const [date, setDate] = useState("");
  const [dateEnd, setDateEnd] = useState("");
  const [heure, setHeure] = useState("09:00");
  const [label, setLabel] = useState("");
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState(null);
  const [blocks, setBlocks] = useState([]);
  const [loadingBlocks, setLoadingBlocks] = useState(true);

  useEffect(() => { fetchBlocks(); }, []);

  async function fetchBlocks() {
    setLoadingBlocks(true);
    const { data, error } = await fetchActiveBlocks().order("date", { ascending: true });
    if (error) console.error("Chargement blocked_slots échoué:", error);
    setBlocks(data || []);
    setLoadingBlocks(false);
  }

  async function addBlock() {
    if (!date) return;
    if (blockType === "range" && !dateEnd) return;
    setSaving(true); setMsg(null);
    const { error } = await supabase.from("blocked_slots").insert([{
      type: blockType, date, date_end: blockType === "range" ? dateEnd : null,
      heure: blockType === "slot" ? heure : null, label: label || null,
    }]);
    if (error) setMsg({ type: "err", text: "Erreur lors de l'enregistrement" });
    else { setMsg({ type: "ok", text: "Créneau bloqué ✓" }); setDate(""); setDateEnd(""); setLabel(""); fetchBlocks(); }
    setSaving(false);
  }

  async function deleteBlock(id) {
    await supabase.from("blocked_slots").delete().eq("id", id);
    fetchBlocks();
  }

  function blockTypeLabel(b) {
    if (b.type === "slot") return `Créneau ${b.heure}`;
    if (b.type === "day") return "Journée entière";
    if (b.type === "range") return `Du ${b.date} au ${b.date_end}`;
    return b.type;
  }

  return (
    <div>
      <div className="block-section">
        <div className="block-section-title">🔒 Bloquer des créneaux</div>
        <div className="block-type-row">
          {[{ id: "slot", label: "⏰ Créneau" }, { id: "day", label: "📅 Journée" }, { id: "range", label: "📆 Plage" }].map(t => (
            <button key={t.id} className={`block-type-btn ${blockType === t.id ? "on" : ""}`} onClick={() => setBlockType(t.id)}>{t.label}</button>
          ))}
        </div>
        <div className="block-field">
          <label className="block-label">{blockType === "range" ? "Date de début" : "Date"}</label>
          <input className="block-input" type="date" value={date} onChange={e => setDate(e.target.value)} />
        </div>
        {blockType === "range" && (
          <div className="block-field">
            <label className="block-label">Date de fin</label>
            <input className="block-input" type="date" value={dateEnd} min={date} onChange={e => setDateEnd(e.target.value)} />
          </div>
        )}
        {blockType === "slot" && (
          <div className="block-field">
            <label className="block-label">Créneau horaire</label>
            <select className="block-select" value={heure} onChange={e => setHeure(e.target.value)}>
              {SLOTS_ALL.map(s => <option key={s} value={s}>{s}</option>)}
            </select>
          </div>
        )}
        <div className="block-field">
          <label className="block-label">Motif (optionnel)</label>
          <input className="block-input" type="text" placeholder="Ex: Vacances, Formation..." value={label} onChange={e => setLabel(e.target.value)} />
        </div>
        <button className="block-btn" onClick={addBlock} disabled={!date || saving}>
          {saving ? "Enregistrement..." : "🔒 Bloquer"}
        </button>
        {msg && <div className={msg.type === "ok" ? "block-success" : "block-error"}>{msg.text}</div>}
      </div>

      <div className="block-section">
        <div className="block-section-title">Blocages actifs ({blocks.length})</div>
        {loadingBlocks && <div className="loading">Chargement...</div>}
        {!loadingBlocks && blocks.length === 0 && <div className="empty">Aucun blocage actif</div>}
        {!loadingBlocks && (
          <div className="block-list">
            {blocks.map(b => (
              <div key={b.id} className="block-item">
                <div className="block-item-info">
                  <div className="block-item-type">{blockTypeLabel(b)}</div>
                  <div className="block-item-date">{b.date}{b.date_end ? ` → ${b.date_end}` : ""}</div>
                  {b.label && <div className="block-item-label">📌 {b.label}</div>}
                </div>
                <button className="block-del" onClick={() => deleteBlock(b.id)}>✕</button>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

// ══════════════════════════════════════════
// STATS VIEW
// ══════════════════════════════════════════
function StatsView({ reservations }) {
  const confirmed = reservations.filter(r => r.statut === "confirmé");
  const cancelled = reservations.filter(r => r.statut === "annulé");
  const now = new Date();
  const thisMonth = confirmed.filter(r => {
    if (!r.date) return false;
    const parts = r.date.split(".");
    return parts[1] === String(now.getMonth() + 1).padStart(2, "0") && parts[2] === String(now.getFullYear());
  });
  const totalRevenue = confirmed.reduce((a, r) => a + (r.total || 0), 0);
  const monthRevenue = thisMonth.reduce((a, r) => a + (r.total || 0), 0);
  const avgRevenue = confirmed.length ? Math.round(totalRevenue / confirmed.length) : 0;
  const cancelRate = reservations.length ? Math.round((cancelled.length / reservations.length) * 100) : 0;
  const svcCount = {}; confirmed.forEach(r => { if (r.service) svcCount[r.service] = (svcCount[r.service] || 0) + 1; });
  const topService = Object.entries(svcCount).sort((a, b) => b[1] - a[1])[0];
  const slotCount = {}; confirmed.forEach(r => { if (r.heure) slotCount[r.heure] = (slotCount[r.heure] || 0) + 1; });
  const topSlot = Object.entries(slotCount).sort((a, b) => b[1] - a[1])[0];
  const dayCount = {}; const dayNames = ["Dimanche","Lundi","Mardi","Mercredi","Jeudi","Vendredi","Samedi"];
  confirmed.forEach(r => { if (r.date) { const p = r.date.split("."); if (p.length >= 3) { const d = new Date(`${p[2]}-${p[1]}-${p[0]}`); const n = dayNames[d.getDay()]; dayCount[n] = (dayCount[n] || 0) + 1; } } });
  const topDay = Object.entries(dayCount).sort((a, b) => b[1] - a[1])[0];
  const clientCount = {}; confirmed.forEach(r => { if (r.nom) clientCount[r.nom] = (clientCount[r.nom] || 0) + 1; });
  const topClient = Object.entries(clientCount).sort((a, b) => b[1] - a[1])[0];
  const suppCount = {}; confirmed.forEach(r => { if (r.supplements) r.supplements.split(",").forEach(s => { const t = s.trim(); if (t) suppCount[t] = (suppCount[t] || 0) + 1; }); });
  const topSupp = Object.entries(suppCount).sort((a, b) => b[1] - a[1])[0];

  const Block = ({ label, value, sub }) => (
    <div style={{ background: "var(--dark)", border: "1px solid var(--border)", borderRadius: 3, padding: "14px 12px" }}>
      <div style={{ fontSize: 8, letterSpacing: "0.2em", color: "var(--muted)", textTransform: "uppercase", marginBottom: 6 }}>{label}</div>
      <div style={{ fontFamily: "'Bebas Neue',sans-serif", fontSize: 22, color: "var(--gold)", lineHeight: 1 }}>{value || "—"}</div>
      {sub && <div style={{ fontSize: 9, color: "var(--muted)", marginTop: 3 }}>{sub}</div>}
    </div>
  );
  const Section = ({ title }) => (
    <div style={{ fontFamily: "'Bebas Neue',sans-serif", fontSize: 14, letterSpacing: "0.12em", color: "var(--muted)", textTransform: "uppercase", margin: "16px 0 8px", borderBottom: "1px solid var(--border)", paddingBottom: 6 }}>{title}</div>
  );

  return (
    <div>
      <Section title="💰 Financier" />
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8, marginBottom: 4 }}>
        <Block label="CHF Total" value={`${totalRevenue} CHF`} />
        <Block label="Ce mois-ci" value={`${monthRevenue} CHF`} sub={`${thisMonth.length} RDV`} />
        <Block label="Moyenne / RDV" value={`${avgRevenue} CHF`} />
        <Block label="Taux annulation" value={`${cancelRate}%`} sub={`${cancelled.length} annulé(s)`} />
      </div>
      <Section title="⭐ Services" />
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8, marginBottom: 4 }}>
        <Block label="Service #1" value={topService?.[0]} sub={`${topService?.[1]} fois`} />
        <Block label="Supplément #1" value={topSupp?.[0]} sub={`${topSupp?.[1]} fois`} />
      </div>
      <Section title="📅 Tendances" />
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8, marginBottom: 4 }}>
        <Block label="Jour chargé" value={topDay?.[0]} sub={`${topDay?.[1]} RDV`} />
        <Block label="Créneau #1" value={topSlot?.[0]} sub={`${topSlot?.[1]} fois`} />
      </div>
      <Section title="👥 Clients" />
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8 }}>
        <Block label="Clients uniques" value={Object.keys(clientCount).length} />
        <Block label="Client fidèle" value={topClient?.[0]} sub={`${topClient?.[1]} RDV`} />
      </div>
    </div>
  );
}

// ══════════════════════════════════════════
// CALENDAR VIEW
// ══════════════════════════════════════════
function CalendarView({ reservations, onCancel, onTerminer, sendingReview }) {
  const today = new Date();
  const [month, setMonth] = useState(today.getMonth());
  const [year, setYear] = useState(today.getFullYear());
  const [selected, setSelected] = useState(null);

  const daysInMonth = new Date(year, month + 1, 0).getDate();
  const firstDay = new Date(year, month, 1).getDay();
  const offset = firstDay === 0 ? 6 : firstDay - 1;

  function getRdvsForDay(day) {
    const dateStr = `${day}.${String(month+1).padStart(2,'0')}.${year}`;
    return reservations.filter(r => r.statut === "confirmé" && r.date && r.date.includes(dateStr))
      .sort((a, b) => a.heure?.localeCompare(b.heure));
  }

  function prevMonth() { if (month === 0) { setMonth(11); setYear(y => y-1); } else setMonth(m => m-1); setSelected(null); }
  function nextMonth() { if (month === 11) { setMonth(0); setYear(y => y+1); } else setMonth(m => m+1); setSelected(null); }

  const selectedRdvs = selected ? getRdvsForDay(selected) : [];

  return (
    <div>
      <div className="cal-nav">
        <button className="cal-nav-btn" onClick={prevMonth}>‹</button>
        <div className="cal-month">{MONTHS_FR[month]} <span>{year}</span></div>
        <button className="cal-nav-btn" onClick={nextMonth}>›</button>
      </div>
      <div className="cal-labels">{DAYS_CAL.map((d, i) => <div key={i} className="cal-label">{d}</div>)}</div>
      <div className="cal-grid">
        {Array(offset).fill(null).map((_, i) => <div key={`e${i}`} />)}
        {Array.from({ length: daysInMonth }, (_, i) => i + 1).map(day => {
          const rdvs = getRdvsForDay(day);
          const isToday = day === today.getDate() && month === today.getMonth() && year === today.getFullYear();
          return (
            <div key={day} onClick={() => setSelected(selected === day ? null : day)}
              className={`cal-day ${isToday ? "today" : ""} ${selected === day ? "sel" : ""}`}>
              <div className="cal-day-num">{day}</div>
              {rdvs.length > 0 && (<><div className="cal-dot" /><div className="cal-count">{rdvs.length}</div></>)}
            </div>
          );
        })}
      </div>
      {selected && (
        <div>
          <div className="cal-detail-title">{selected} {MONTHS_FR[month]} — {selectedRdvs.length} RDV</div>
          {selectedRdvs.length === 0 ? <div className="empty">Aucun RDV ce jour</div> : selectedRdvs.map(r => (
            <div key={r.id} className="rdv-card">
              <div className="rdv-top">
                <div className="rdv-name">{r.nom}</div>
                <div style={{ fontSize: 13, color: "var(--gold)" }}>{r.heure}</div>
              </div>
              <div className="rdv-info">
                <div><div className="rdv-info-label">Service</div><div className="rdv-info-val gold">{r.service}</div></div>
                <div><div className="rdv-info-label">Total</div><div className="rdv-info-val gold">{r.total} CHF</div></div>
                <div><div className="rdv-info-label">Téléphone</div><div className="rdv-info-val">{r.telephone}</div></div>
                {r.supplements && <div><div className="rdv-info-label">Suppléments</div><div className="rdv-info-val" style={{fontSize:9}}>{r.supplements}</div></div>}
              </div>
              <div className="rdv-actions">
                <button className="rdv-btn rdv-btn-call" onClick={() => window.open(`tel:${r.telephone}`)}>📞 Appeler</button>
                <button className="rdv-btn rdv-btn-done" onClick={() => onTerminer(r)} disabled={sendingReview === r.id}>
                  {sendingReview === r.id ? "Envoi..." : "⭐ Terminer"}
                </button>
                <button className="rdv-btn rdv-btn-cancel" onClick={() => onCancel(r.id)}>✕ Annuler</button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
